import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

const BalanceHistoryItemSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string().nullable().optional(),
    user_id: z.string().nullable().optional(),
    user_name: z.string().nullable().optional(),
    date: z.string(),
    starting_balance: z.coerce.number(),
    ending_balance: z.coerce.number().nullable().optional(),
    note: z.string().nullable().optional(),
});

export const BalanceHistoryResponseSchema = z.object({
    data: z.array(BalanceHistoryItemSchema),
    pagination: PaginationResponseSchema,
    message: z.string().optional(),
    statusCode: z.number().optional(),
});

export const TodayBalanceResponseSchema = z.object({
    data: BalanceHistoryItemSchema.nullable(),
    message: z.string().optional(),
    statusCode: z.number().optional(),
});

export type BalanceHistoryItem = z.infer<typeof BalanceHistoryItemSchema>;
export type BalanceHistoryResponse = z.infer<
    typeof BalanceHistoryResponseSchema
>;
export type TodayBalanceItem = z.infer<typeof BalanceHistoryItemSchema>;
